<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Pedidos Encontrados
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
        <mat-card-content class="no-padding">
            <div>
                <table id="relatorios" mat-table [dataSource]="pedidoCollection" class="table-sm">
                    <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef class="text-center" class="checkbox" scope="col">
                        </th>
                        <td mat-cell *matCellDef="let item" class="text-center" class="checkbox">
                            <mat-checkbox color="primary" *ngIf="pedidoCollection.data && pedidoCollection.data.length"
                                (change)="select(item, $event.checked)" [checked]="item.selected"
                                [disableControl]="pedidoIds.length > 0">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="linha" *ngIf="!isMobile">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Linha</th>
                        <td mat-cell *matCellDef="let item;let index = index;" class="text-center">
                            {{ index + 1 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="pedidoId">
                        <th mat-header-cell *matHeaderCellDef class="text-center">NRT</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.pedidoId }}</td>
                    </ng-container>

                    <ng-container matColumnDef="documento">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Documento</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.documento }}</td>
                    </ng-container>

                    <ng-container matColumnDef="volume" *ngIf="!isMobile">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Volume</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.volume }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cliente">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Cliente</th>
                        <td mat-cell *matCellDef="let item" class="text-center">
                            {{ item.cliente.length > 10 ? item.cliente.substring(0, 10) + '...' : item.cliente }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div *ngIf="!isLoading && pedidoCollection?.data?.length === 0"
                    class="d-flex justify-content-center align-items-center" style="height: 100px;">
                    Nenhum registro foi encontrado!
                </div>
                <mat-paginator [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
                    (page)="onPageChange($event)" [pageSizeOptions]="[5]"></mat-paginator>
            </div>

        </mat-card-content>
        <mat-divider *ngIf="!isMobile"></mat-divider>
        <div>
        </div>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button mat-dialog-close color="primary" [disabled]="!pedidoIds || pedidoIds.length === 0"
            (click)="apply()">Escolher</button>
    </div>
</div>
